export default __webpack_public_path__ + "static/media/上门喂养勋章.b6823e6b.png";